import { Spin } from 'antd';
import { BubbleChart } from '@components/charts';
import { useWidgetData } from '@hooks/useWidgetData';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';

interface Data {
  data: Array<{ x: number; y: number; size: number; name?: string }>;
}

function BubbleWidget({ instance }: WidgetRenderProps) {
  const { data, isLoading } = useWidgetData<Data>(
    instance.id, 'bubble', instance.config as Record<string, unknown>, instance.refreshInterval,
  );
  if (isLoading) return <Spin />;
  return <BubbleChart data={data?.data ?? []} />;
}

export const bubbleWidgetDef: WidgetDefinition = {
  type: 'bubble',
  name: 'Bubble Chart',
  description: 'Three-dimensional scatter',
  icon: 'CloudOutlined',
  category: 'chart',
  defaultTitle: 'Bubble Chart',
  defaultConfig: {},
  minW: 4, minH: 4, defaultW: 6, defaultH: 6,
  component: BubbleWidget,
  settingsSchema: { fields: [] },
};
